<div class="card">
  <div class="card-header p-2">
    @if (hasMiUser() && hasUrpUser()) {
      <button class="btn btn-primary btn-sm btn-floating float-end" routerLink="/urp/woche">
        <i class="fal fa-calendar-alt" aria-hidden="true"></i>
      </button>
      <a class="btn btn-primary btn-sm btn-floating float-end me-1" [routerLink]="['/urp/tag', currentDatum()]">
        <i class="fal fa-calendar" aria-hidden="true"></i>
      </a>
      @if (showUrpStatistik()) {
        <button
          class="btn btn-primary btn-sm btn-floating float-end me-1"
          [routerLink]="['/urp/statistik', currentJahr()]"
        >
          <i class="fal fa-chart-bar" aria-hidden="true"></i>
        </button>
      }
    }
    <h4 class="card-title mb-0 mt-1">
      <i class="fal fa-clock" aria-hidden="true"></i>
      Rapport
    </h4>
  </div>
  @if (!hasMiUser() || !hasUrpUser()) {
    <div class="card-body b2-card pe-2">
      <p class="card-text">
        @if (!hasMiUser()) {
          <span>
            Rapportierung kann nicht verwendet werden. Dem Benutzer wurde im Bauplus kein Mitarbeiter zugewiesen.
          </span>
        }
        @if (hasMiUser() && !hasUrpUser()) {
          <span>
            Rapportierung kann nicht verwendet werden. Es gibt im Bauplus keinen Tagesrapport (Typ M) oder Monatsrapport
            zum Benutzer.
          </span>
        }
      </p>
    </div>
  }
  @if (hasMiUser() && hasUrpUser()) {
    <div class="card-body b2-card pe-2 hand" routerLink="/urp/woche">
      <div class="card-text">{{ miName() }}</div>
    </div>
  }
</div>
